import { AfterViewInit, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { ItemListLimitTimeParamComponent } from 'src/app/partsCommon/item-list-limit-time-param/item-list-limit-time-param.component';
import { ItemSearchCondition } from 'src/app/partsCommon/item-select-condition/item-select-condition.component';
import { CommonService } from 'src/app/service/common.service';
import { HttpBasicService } from 'src/app/service/http-basic.service';

@Component({
  selector: 'app-limit-time-param-setting',
  templateUrl: './limit-time-param-setting.component.html',
  styleUrls: ['./limit-time-param-setting.component.css']
})
export class LimitTimeParamSettingComponent implements OnInit, AfterViewInit {

  public recordCount: number;
  public isReadonly: boolean;
  public itemSearchCondition: ItemSearchCondition = new ItemSearchCondition(this.fb);
  public itemSearchConditionOrigin: ItemSearchCondition = new ItemSearchCondition(this.fbOrigin);
  public orderStopFlagValues: number[];

  public displayColumnIds: string[];
  public tableWidth: any;
  public pagenatorMaxWidth: any;

  @ViewChild(ItemListLimitTimeParamComponent, { static: true }) ItemListLimitTimeParamComponent: ItemListLimitTimeParamComponent;
  @ViewChild("matPagenatorItem", { static: false }) matPagenatorItem: MatPaginator;

  constructor(
    public commonService: CommonService,
    private httpBasic: HttpBasicService,
    private fb: FormBuilder,
    private fbOrigin: FormBuilder
  ) {
    this.orderStopFlagValues = [];
    let flagList = this.commonService.getOrderStopSearchCondList();
    for (let i = 0; i < flagList.length; i++) {
      let flag = flagList[i];
      if (!flag.paramEditable) continue;
      if (flag.caseItem) continue;
      this.orderStopFlagValues.push(flag.value);
    }
  }
  ngOnInit(): void {
    this.commonService.pageTitle = this.commonService.pageMenuName;
    this.isReadonly = this.commonService.checkPrivilege("limitTimeParamSetting");
    this.itemSearchCondition.formGroup.get('salesDate').setValue(this.commonService.dateSalesDate);
    this.itemSearchCondition.formGroup.get('salesDate').disable();
  }

  ngAfterViewInit(): void {
    this.doQuery(0);
  }

  ngOnDestroy() {
  }

  @HostListener('window:resize', ['$event'])
  handleResize() {
    this.setTableHeight();
  }

  setTableHeight() {
    setTimeout(() => { this.setTableHeightBody(); }, 0);
  }

  setTableHeightBody() {
    let id = "item-list-inner";
    let remHeight = this.commonService.getHeightBelow(id);
    let paginatorHeight = 56;
    let margin = 5;
    let height = remHeight - paginatorHeight - margin;
    if (height < 200) height = 200;

    let elem = document.getElementById(id);
    if (elem) elem.style.maxHeight = "" + height + "px";
  }

  doQuery(mode: number) {
    this.copyRequest();
    this.setTableHeight();
    if (this.ItemListLimitTimeParamComponent.isDisable()) {
      this.ItemListLimitTimeParamComponent.doQuery(mode);
    } else {
      let subsc = this.commonService.openYesNoDialog(this.commonService.pageTitle, "変更が保存されていません。変更内容を破棄しますか？").subscribe(
        (response: boolean) => {
          subsc.unsubscribe();
          if (response) {
            this.ItemListLimitTimeParamComponent.doQuery(mode);
          }
        });
    }
  }

  copyRequest() {
    this.itemSearchConditionOrigin.formGroup = this.itemSearchCondition.cloneAbstractControl(this.itemSearchCondition.formGroup);
    this.itemSearchConditionOrigin.ctgSelectCondition.formGroup.patchValue(this.itemSearchCondition.ctgSelectCondition.formGroup.value);
    this.itemSearchConditionOrigin.rackSelectCondition.formGroup.patchValue(this.itemSearchCondition.rackSelectCondition.formGroup.value);
    this.itemSearchConditionOrigin.formGroup.get('salesDate').setValue(this.commonService.dateSalesDate);
    this.itemSearchConditionOrigin.formGroup.get('salesDate').disable();
  }

  canDeactivate() {
    if (this.ItemListLimitTimeParamComponent.isDisable()) return true;
    return this.commonService.openYesNoDialog(this.commonService.pageTitle, "変更が保存されていません。変更内容を破棄しますか？");
  }
}
